import { setLoading } from 'actions';
import { setOrders, clearOrders } from 'actions/tools/OrdersSearchActions';
import { showError } from '../../util/errorPopupUtil';
import * as salesforceOrderApi from '../../api/orders/salesforce';

export const searchSalesforceOrdersById = (simplrAccountPtrId, orderId) => async (dispatch) => {
  dispatch(clearOrders());
  dispatch(setLoading(true, 'searchPage'));
  try {
    const orders = await salesforceOrderApi.getSalesforceOrderByOrderId({ simplrAccountPtrId, orderId });
    dispatch(setOrders(orders.items));
  } catch (error) {
    showError(error);
  } finally {
    dispatch(setLoading(false, 'searchPage'));
  }
};

export const searchSalesforceOrdersByEmail = (simplrAccountPtrId, email) => async (dispatch) => {
  dispatch(clearOrders());
  dispatch(setLoading(true, 'searchPage'));
  try {
    const orders = await salesforceOrderApi.getSalesforceOrderByEmail({ simplrAccountPtrId, email });
    dispatch(setOrders(orders.items));
  } catch (error) {
    showError(error);
  } finally {
    dispatch(setLoading(false, 'searchPage'));
  }
};
